import { useSelector } from "react-redux";
import { AppDispatch } from "store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import classesStock from "../../../popover.module.scss";
import classes from "../../../../../../components/Popover/popover.module.scss";
import { styles as popoverSelectStyles } from "../../../../../../components/Popover/popoverSelectStyle";
import ProjectSelect from "Dashboard/scenes/Projects/components/ProjectSelect";
import { useProjectOptions } from "Dashboard/hooks/ProjectsOptions";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { IStockOutputUpdate } from "Dashboard/scenes/Stock/domain/IStockOutputUpdate";
import {
  selectState,
  setEditDetailsPopover,
  updateStockOutput,
} from "../outputSlice";

interface IProps {
  dispatch: AppDispatch;
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const EditOutputDetails = ({
  dispatch,
  setClickOutsideActive,
}: IProps) => {

  const { outputForEdit } = useSelector(selectState);
  const projects = useProjectOptions({ showHiddenInDropDowns: true });
  const [projectId, setProjectId] = useState<number | undefined>(undefined);
  const [overrideProjectId, setOverrideProjectId] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (outputForEdit) {
      setProjectId(outputForEdit.project?.projectId);
      setOverrideProjectId(outputForEdit.projectOverride?.projectId);
    }
  }, [outputForEdit]);

  if (outputForEdit === null) {
    return (<>GREŠKA</>);
  }

  const isActive = (id?: number) => !!projects.find((o) => o.value === id)?.active;

  const project = outputForEdit.project;
  const projectOverride = outputForEdit.projectOverride;
  const isProjectEditable = !project || isActive(project.projectId);
  const isOverrideEditable = !projectOverride || isActive(projectOverride.projectId);

  const getSubmitData = (): IStockOutputUpdate => {
    return {
      outputId: outputForEdit.outputId,
      outputItemId: outputForEdit.items[0].outputItemId,
      projectId: projectId,
      overrideProjectId: overrideProjectId ?? null,
    };
  };

  const handleSuccessfulEdit = () => {
    dispatch(setEditDetailsPopover({ isOpen: false }));
    toast.success("Izmena je zabeležena");
  };

  const onSubmit = async () => {
    try {
      await dispatch(updateStockOutput(getSubmitData())).unwrap();
      handleSuccessfulEdit();
    } catch (status) {
      if (status === 403) {
        toast.error("Nije dozvoljena izmena u lageru (da li ste zaposleni u firmi?)");
      } else {
        toast.error("Izmena nije zabeležena zbog neočekivane greške");
      }
    }
  };

  return (
    <form
      className={`${classesStock.newStockOutputPopover} ${classes.basicPopover}`}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>izdajem za projekat</label>
          {isProjectEditable
            ? <ProjectSelect
              options={projects}
              defaultValue={project?.projectId}
              customStyles={popoverSelectStyles.customStyleClassic}
              onChange={(value: number | null) => setProjectId(value ?? undefined)}
            />
            : <div>
              <input className={classes.subInput}
                value={project.projectName} disabled />
            </div>}
        </div>
      </div>

      <div className={`${classes.row} ${classesStock.paragraph}`}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>ime na otpremnici<br />i trebovanju</label>
          {isOverrideEditable
            ? <ProjectSelect
              options={projects}
              defaultValue={projectOverride?.projectId}
              customStyles={popoverSelectStyles.customStyleClassic}
              onChange={(value: number | null) => setOverrideProjectId(value ?? undefined)}
            />
            : <div>
              <input className={classes.subInput}
                value={projectOverride.projectName} disabled />
            </div>}
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.buttons}`}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default EditOutputDetails;
